import { css } from '@emotion/react';

export const partialsBooksBackendOverrideStyle = css`
  * {
    box-sizing: border-box;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
  }

  *:link,
  *:visited {
    color: inherit;
  }
`;
